<template>
    <div>
        <van-image  width="100%" height="200px" fit="cover" :src="siteDetail.image_src" style="display: block"></van-image>
        <div class="title">{{siteDetail.name}}</div>
        <van-cell-group>
            <van-cell v-if="siteDetail.telphone" icon="phone">
                <van-row type="flex" justify="space-between">
                    <van-col style="padding-right:10px;">联系电话：{{siteDetail.telphone}}</van-col>
                    <van-col style="width: 60px;">
                        <van-button type="info" size="small" round block>
                            <van-icon name="phone" style="font-size: 16px" @click="call" />
                        </van-button>
                    </van-col>
                </van-row>
            </van-cell>
            <van-cell v-if="siteDetail.address" icon="location">
                <van-row type="flex" justify="space-between">
                    <van-col style="padding-right:10px;">{{siteDetail.address}}</van-col>
                    <van-col style="width: 80px;">
                        <van-button type="info" size="small" round block @click="navigation">导航</van-button>
                    </van-col>
                </van-row>
            </van-cell>
            <van-cell v-if="siteDetail.introduce" icon="shop" :value="siteDetail.introduce"></van-cell>
        </van-cell-group>
        <van-divider v-if="siteDetail.oil_price_data.length > 0">今日油价</van-divider>
        <van-grid v-if="siteDetail.oil_price_data.length > 0" :column-num="2" :gutter="10" style="margin-bottom: 20px;">
            <van-grid-item v-for="(oilPriceItem, index) in siteDetail.oil_price_data" :key="index">
                <div style="margin-bottom: 5px; font-size: 12px; color: #333333;">{{oilPriceItem.oil_type.name}}</div>
                <div>
                    <span style="font-size: 20px; color: red;">{{oilPriceItem.price}}</span>
                    <span style="font-size: 12px; color: #888888;">元/升</span>
                </div>
            </van-grid-item>
        </van-grid>
    </div>
</template>

<script>
    import wx from 'weixin-js-sdk';
    import api from "../../assets/js/api";

    export default {
        name: "Detail",
        data(){
            return {
                siteDetail : {
                    oil_price_data: []
                },
            };
        },
        created() {
            let self = this;
            api.request('/site/detail', {
                'id' : this.$route.query.site_id,
            }).then(res => {
                self.siteDetail = res.data;
            })
        },
        methods : {
            call(){
                window.location = 'tel:' + this.siteDetail.telphone;
            },
            navigation(){
                wx.openLocation({
                    latitude: this.siteDetail.latitude,
                    longitude: this.siteDetail.longitude,
                    name: this.siteDetail.name,
                    address: this.siteDetail.address,
                    scale: 16
                });
            },
        },
    }
</script>

<style scoped>
    .title{
        padding: 15px 0 20px 15px;
        font-size: 20px;
        background-color: #ffffff;
        font-weight: bold;
    }
</style>



// WEBPACK FOOTER //
// src/pages/site/Detail.vue